import { inject, Injectable } from '@angular/core';
import { catchError, type Observable, of } from 'rxjs';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    SelectFilterModel,
} from '@ui/shared/util-filter';
import { CultureMapService } from '@ui/shared/util-api';
import { CultureMapFilterKey } from '../../enums/culture-map-filter-key';
import { toDataResult, ToResult } from '@team23/ts-result';
import { CulturalKindMapper } from '../../mappers/cultural-kind-mapper';

@Injectable({ providedIn: 'root' })
export class KindSelectFilterConfigService extends FilterConfigService<CultureMapFilterKey, CultureMapService> {

    constructor() {
        super(
            new SelectFilterModel(CultureMapFilterKey.Kind, 'Art der Ergebnisse', []),
            inject(CultureMapService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of(CulturalKindMapper.getValues())
            .pipe(
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
